import type { MessageDescriptor } from 'react-intl';
import { APP_DICTIONARY } from '@/common/messages/root';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { DateRangePickerTab } from './constants';

export const DateRangePickerTabTranslated: Record<DateRangePickerTab, MessageDescriptor> = defineMessages({
  [DateRangePickerTab.Predefined]: {
    id: 'components.form.date_range_picker.tab.predefined',
  },
  [DateRangePickerTab.Custom]: APP_DICTIONARY.custom,
});

export const DateRangePickerMessages = defineMessages({
  placeholder: {
    id: 'components.form.date_range_picker.placeholder',
  },
  last: {
    id: 'components.form.date_range_picker.last',
  },
  lastFeminine: {
    id: 'components.form.date_range_picker.lastFeminine',
  },
  year: {
    id: 'components.form.date_range_picker.year',
  },
  custom: APP_DICTIONARY.custom,
});
